/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductionSitesFilterOptionsByOrganizationIdQueryResponse,
  FindProductionSitesFilterOptionsByOrganizationIdPathParams,
  FindProductionSitesFilterOptionsByOrganizationIdQueryParams,
} from "../types/FindProductionSitesFilterOptionsByOrganizationId.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductionSitesFilterOptionsByOrganizationIdQueryKey = (
  organizationId:
    | FindProductionSitesFilterOptionsByOrganizationIdPathParams["organizationId"]
    | undefined,
  params?: FindProductionSitesFilterOptionsByOrganizationIdQueryParams
) =>
  [
    {
      url: "/v1/production-site/find-filter-options/:organizationId",
      params: { organizationId: organizationId },
    },
    ...(params ? [params] : []),
  ] as const

export type FindProductionSitesFilterOptionsByOrganizationIdQueryKey =
  ReturnType<typeof findProductionSitesFilterOptionsByOrganizationIdQueryKey>

/**
 * @summary Find production site filter options by organization
 * {@link /v1/production-site/find-filter-options/:organizationId}
 */
export async function findProductionSitesFilterOptionsByOrganizationId(
  organizationId: FindProductionSitesFilterOptionsByOrganizationIdPathParams["organizationId"],
  params?: FindProductionSitesFilterOptionsByOrganizationIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductionSitesFilterOptionsByOrganizationIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/production-site/find-filter-options/${organizationId}`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductionSitesFilterOptionsByOrganizationIdQueryOptions(
  organizationId:
    | FindProductionSitesFilterOptionsByOrganizationIdPathParams["organizationId"]
    | undefined,
  params?: FindProductionSitesFilterOptionsByOrganizationIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductionSitesFilterOptionsByOrganizationIdQueryKey(
    organizationId,
    params
  )
  return queryOptions<
    ResponseConfig<FindProductionSitesFilterOptionsByOrganizationIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductionSitesFilterOptionsByOrganizationIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!organizationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductionSitesFilterOptionsByOrganizationId(
        organizationId!,
        params,
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @summary Find production site filter options by organization
 * {@link /v1/production-site/find-filter-options/:organizationId}
 */
export function useFindProductionSitesFilterOptionsByOrganizationId<
  TData =
    ResponseConfig<FindProductionSitesFilterOptionsByOrganizationIdQueryResponse>,
  TQueryData =
    ResponseConfig<FindProductionSitesFilterOptionsByOrganizationIdQueryResponse>,
  TQueryKey extends QueryKey =
    FindProductionSitesFilterOptionsByOrganizationIdQueryKey,
>(
  organizationId:
    | FindProductionSitesFilterOptionsByOrganizationIdPathParams["organizationId"]
    | undefined,
  params?: FindProductionSitesFilterOptionsByOrganizationIdQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductionSitesFilterOptionsByOrganizationIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findProductionSitesFilterOptionsByOrganizationIdQueryKey(
      organizationId,
      params
    )

  const query = useQuery(
    {
      ...findProductionSitesFilterOptionsByOrganizationIdQueryOptions(
        organizationId,
        params,
        config
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
